import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { DataGrid } from '@material-ui/data-grid'
import moment from 'moment'
import _ from 'lodash'
import { IconButton, TextField, Tooltip } from '@material-ui/core';
import { Assignment } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';


const useStyles = makeStyles((theme)=> ({
    root: {
        display: 'flex', 
        flexDirection: 'column', 
        height: '600px'
    },
    iconButton: {
        marginLeft: theme.spacing(1)
    },
    batchTextField: {
        display: 'flex',
        paddingBottom: theme.spacing(2)
    }
}))

function SelectDispatchHistory(props){
    const {t} = useTranslation('common')
    let {data, isLoading} = props

    const classes = useStyles()

    const [textReferrer, setTextReferrer] = useState("")
    const [selectedReferrer, setSelectedReferrer] = useState("")

    const columns = [
        {field: 'long_name', headerName: t('creator'), flex: 1},
        {field: 'name', headerName: t('code_name'), width: 100},
        {field: 'create_time', headerName: t('date'), type: 'date', flex: 1,
            valueFormatter: (params)=> moment.unix(params.value).format("MMM DD, YYYY - HH:mm:ss")}
    ]

    return (
        <div className={classes.root}>
            <form className={classes.batchTextField}>
                <TextField 
                    placeholder={t('mapManagement:batch_number_placeholder')}
                    variant="outlined" 
                    size='small' 
                    fullWidth
                    value={textReferrer}
                    onChange={(event)=>{
                        onChangeTextReferrer(event.target.value)
                    }}
                />
                <Tooltip title="Paste">
                    <IconButton 
                        aria-label="referrer-paste" 
                        className={classes.iconButton}
                        onClick={_handlePasteFromClipboard}
                    >
                        <Assignment fontSize='small'/>
                    </IconButton>
                </Tooltip>
            </form>
            <div style={{display: 'flex', height: '100%'}}>
                <div style={{flexGrow: 1}}>
                    <DataGrid 
                        columns={columns}
                        rows={data}
                        sortModel={[{
                            field: "create_time",
                            sort: 'desc'
                        }]}
                        onSelectionModelChange={(newSelection) => {
                            let id = parseInt(_.first(newSelection))
                            let dispatchGroup = _.find(data, {'id': id})
                            if(dispatchGroup === undefined)
                                return
                            if(!_.has(dispatchGroup, 'dispatch_details'))
                                return
                            setSelectedReferrer(dispatchGroup['dispatch_details'])
                            let combine = dispatchGroup['dispatch_details']
                            if(textReferrer.length > 0)
                                combine = `${textReferrer},${dispatchGroup['dispatch_details']}`
                            props.handleSelectedDispatchGroup(combine)
                            props.handleSelectDispatchId(newSelection)
                        }}
                        loading={isLoading}
                        autoPageSize
                        disableColumnFilter
                        disableColumnMenu
                        disableMultipleSelection={true}
                    />
                </div>
            </div>
        </div>
    )

    function onChangeTextReferrer(text){
        let combine = text
        setTextReferrer(text)
        if(selectedReferrer.length > 0)
            combine = `${selectedReferrer},${text}`
        props.handleSelectedDispatchGroup(combine)
    }

    function _handlePasteFromClipboard(){
        navigator.clipboard.readText().then(text=>onChangeTextReferrer(text))
    }
}

export default React.memo(SelectDispatchHistory)